import { IColumnConfig } from "../configuration";
import { labels, currentResource, getFormattedDate } from "../../util/utils";
import _ = require("lodash");

export class TaskReferenceSheetConfiguration implements IColumnConfig {
  columns: any[];
  formatDependenetAPICallData: Function;

  constructor() {
    this.columns = [
      {
        CellHeader: currentResource.OstTaskReferenceSheetColumns.updateEyCanvas,
        DisplayCell: "A3",
        ReduceWidthForColumn: "B",
      },
      {
        cellHeader: currentResource.OstTaskReferenceSheetColumns.timePhase,
        MergeDisplayCells: "C3:F3",
        ReduceWidthForColumn: "G",
        SubheaderDetails: {
          SubHeaders: [
            currentResource.OstTaskReferenceSheetColumns.timephasename,
            currentResource.OstTaskReferenceSheetColumns.startDate,
            currentResource.OstTaskReferenceSheetColumns.endDate,
            currentResource.OstTaskReferenceSheetColumns.timePhaseId,
          ],
          DataAttribute: "timephases",
          SubHeaderDisplayCells: "C4:F4",
          DisplayCellDisplayCellStartingCell: "C5",
          SubHeadsersFormatting: {
            Horizontalallignment: {
              Left: ["C"],
            },
          },
        },
      },
      {
        cellHeader: currentResource.OstTaskReferenceSheetColumns.taskGroup,
        MergeDisplayCells: "H3:J3",
        ReduceWidthForColumn: "K",
        SubheaderDetails: {
          SubHeaders: [
            currentResource.OstTaskReferenceSheetColumns.taskGroupName,
            currentResource.OstTaskReferenceSheetColumns.groupName,
            currentResource.OstTaskReferenceSheetColumns.taskGroupId,
          ],
          DataAttribute: "taskGroups",
          SubHeaderDisplayCells: "H4:J4",
          DisplayCellDisplayCellStartingCell: "H5",
          SubHeadsersFormatting: {
            Horizontalallignment: {
              Left: ["I"],
            },
          },
        },
      },
      {
        cellHeader: currentResource.OstTaskReferenceSheetColumns.tags,
        MergeDisplayCells: "L3:P3",
        //ReduceWidthForColumn: "Q",
        SubheaderDetails: {
          SubHeaders: [
            currentResource.OstTaskReferenceSheetColumns.tagDescription,
            currentResource.OstTaskReferenceSheetColumns.tagGroup,
            currentResource.OstTaskReferenceSheetColumns.tagLabel,
            currentResource.OstTaskReferenceSheetColumns.tagColor,
            currentResource.OstTaskReferenceSheetColumns.tagId,
          ],
          DataAttribute: "tags",
          SubHeaderDisplayCells: "L4:P4",
          DisplayCellDisplayCellStartingCell: "L5",
          SubHeadsersFormatting: {
            Horizontalallignment: {
              Left: ["M", "N"],
            },
          },
        },
      },
    ];
  }

  public formatDependentAPICallData = (response, ldcVersioning, IndexToStartReadingData) => {
    let timephases = response[IndexToStartReadingData]?.data;

    timephases = timephases?.flatMap((timePhaseType) =>
      timePhaseType.timePhases.map((timePhase) => {
        let name = `${timePhase.periodName}`;
        return [
          name,
          timePhase.startDate ? getFormattedDate(timePhase.startDate?.split("T")[0], 3) : "",
          timePhase.dueDate ? getFormattedDate(timePhase.dueDate?.split("T")[0], 3) : "",
          timePhase.id,
        ];
      })
    );

    let taskSections = response[IndexToStartReadingData + 1].data;

    // Sort taskSections based on uiDisplayOrder before mapping
    taskSections = Object.values(_.groupBy(taskSections, (taskSection) => taskSection.auditPhaseId)).flatMap((group) =>
      group.sort((a, b) => a.uiDisplayOrder - b.uiDisplayOrder)
    );

    let taskGroups = taskSections?.map((taskSection) => {
      const auditphase = currentResource.filterAuditPhases[taskSection.auditPhaseId];
      let taskSectionName = taskSection.taskGroupSectionName;
      let taskGroupName = auditphase + ": " + taskSectionName;
      let taskGroupId = taskSection?.taskSectionId ?? "";
      return [taskGroupName, taskSectionName, taskGroupId];
    });

    let tags = response[IndexToStartReadingData + 2].data?.data;

    if (tags) {
      // Group tags by engagementTagGroupId
      let grouped = Object.values(_.groupBy(tags, (tag) => tag.engagementTagGroupId));

      // Sort groups by engagementTagGroupName (first tag in each group)
      grouped = grouped.sort((a, b) => a[0].engagementTagGroupName.localeCompare(b[0].engagementTagGroupName));

      // Sort each group by engagementTagGroupName and build the final 2D array
      tags = grouped.flatMap((group) =>
      group
        .sort((a, b) => a.engagementTagName.localeCompare(b.engagementTagName))
        .map((tag) => {
        const engagementTagGroupName = tag.engagementTagGroupName;
        const colorCode =
          currentResource.colorOptionsLabels.find((color) => color.value == tag.colorCode)?.label || tag.colorCode;
        const updatedTagName = tag.engagementTagName;
        const tagsDescription = `${engagementTagGroupName}: ${updatedTagName} (${colorCode})`;
        return [tagsDescription, engagementTagGroupName, updatedTagName, colorCode, tag.engagementTagId];
        })
      );
    } else {
      tags = [];
    }

    return {
      timephases: timephases,
      taskGroups: taskGroups,
      tags: tags,
      // picSignOffRequired: picSignOffRequired,
      // eqrSignOffRequired: eqrSignOffRequired,
    };
  };
}
